/**
 * Subheading Component
 * Renders the main heading (`.dsl-heading`) that displays beneath the logo and
 * changes with navigation. (The smaller text rendered under it elsewhere uses
 * the `.dsl-subheading` class.)
 * Wrap words in *asterisks* to highlight them in brand red.
 * e.g. "EXPLORE THE *FUTURE* OF SPACE"
 * NOTE: the DSL nav heading itself no longer shows this highlight — it's
 * neutralised via CSS (`.dsl-heading .dsl-heading-highlight` inherits the heading
 * colour/weight). The highlight is still used elsewhere (location/Orion panels,
 * cycling text), which render the span OUTSIDE `.dsl-heading`, so they keep red.
 * Use |pipes| to keep a phrase from wrapping. e.g. "EXPLORE |THE FUTURE| OF SPACE"
 */

export function parseHighlights(text) {
  // Split on both *highlight* and |nowrap| markers
  const parts = text.split(/(\*[^*]+\*|\|[^|]+\|)/)
  return parts.map((part, i) => {
    if (/^\*[^*]+\*$/.test(part))
      return <span key={i} className="dsl-heading-highlight">{part.slice(1, -1)}</span>
    if (/^\|[^|]+\|$/.test(part))
      return <span key={i} className="dsl-heading-nowrap">{part.slice(1, -1)}</span>
    return part
  })
}

export function Subheading({ text = 'Explore the Future of Space', size, className = '', imageSrc = null, imageHeight = 48 }) {
  return (
    <div className={`dsl-heading ${className}`} style={size ? { fontSize: size } : undefined}>
      {imageSrc
        ? <img src={imageSrc} alt="" className="dsl-heading-img" />
        : parseHighlights(text)
      }
    </div>
  )
}

export default Subheading
